import { useRoutes } from 'react-router-dom';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import ThemeProvider from './theme/ThemeProvider';
import { CssBaseline } from '@mui/material';
import './App.css';
import { routes } from './router';
import LoadingWrapper from './components/LoadingWrapper/LoadingWrapper';

const App = () => {

  const content = useRoutes(routes);

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        <LoadingWrapper />
        {content}
      </LocalizationProvider>
    </ThemeProvider>
  );
};
export default App;
